<template>
  <el-main class="userwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>其他管理</el-breadcrumb-item>
        <el-breadcrumb-item>后台管理日志</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div>
          <el-button @click="exportBkUserToExcel" v-if="NodeInclude('209')">导出数据</el-button>
        </div>
        <div>
          时间： <el-date-picker v-model="range" type="daterange" size="small" value-format="yyyy-MM-dd"
            @change="selectData" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            style="width: 240px;"></el-date-picker>
        </div>
      </div>
      <el-table :data="tableData" stripe style="width: 100%;">
        <el-table-column prop="create_time" label="时间" min-width="120"> </el-table-column>
        <el-table-column prop="nickname" label="账号" min-width="120"></el-table-column>
        <el-table-column prop="ip" label="IP地址" min-width="120"></el-table-column>
        <el-table-column prop="pageName" label="行为" min-width="120"></el-table-column>
      </el-table>
      <div class="apage">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="1"
          :page-size="30" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
// import _ from 'lodash'

export default {
  name: 'adminLog',
  data() {
    return {
      nodeLimtList: [],
      form: {
        time: '',
        type: '',
        status: '',
      },
      tableData: [],
      range: [],
      total: 10,
    }
  },
  computed: {

  },
  // sex 性别(0未知 1男 2女)，
  // 	 *		isbind 是否注册(0未注册 1已注册)，subscribe 是否关注公众号(0未关注 1已关注)
  mounted() {
    this.getBkUserAccessList()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    exportBkUserToExcel() {
      const [start_time, end_time] = this.range
      window.location = api.exportBkUserToExcel({
        start_time,
        end_time,
      })
    },
    selectData(v) {
      console.log(v)
      const [start_time, end_time] = v || []
      this.getBkUserAccessList({ start_time, end_time })
    },
    getBkUserAccessList(option = {}) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const postData = {
        p: this.p,
        ...option,
      }
      api.getBkUserAccessList(postData).then((res) => {
        // console.log(res)
        this.tableData = res.itemList
        this.total = +res.totalNum
        // console.log(this.tableData)
      })
    },
    handleCurrentChange(p) {
      this.p = p

      this.getBkUserAccessList()
      // console.log('submit!')
    },
    handleSizeChange() {
      // console.log('submit!')
    },
    onSubmit() {
      // console.log('submit!')
    },
  },
}
</script>

<style lang="scss" scoped>
.linkwrap {
  display: flex;
  justify-content: space-between;
}

.link {
  color: var(--text-1); /* 0819修改 */
}

.userwrap {
  .filterwrap {
    display: flex;
    justify-content: space-between;
    padding: 0 0 15px 0;

    .el-button {
      margin: 0;
    }
  }

  .apage {
    background: var(--bg); /* 0819修改 */
    padding: 8px;
    text-align: right;
  }

  .el-select {
    margin-right: 20px;
  }

  .el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
    height: 36px;
    line-height: 36px;
    border: none;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;
  }

  .table {
    @extend %box;
    padding: 30px;
  }

  .line {
    text-align: center;
  }
}
</style>